5<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="relative z-10" @close="sendResponse('cancel')">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity backdrop-blur-sm"
        />
      </TransitionChild>

      <div class="fixed z-10 inset-0 overflow-y-auto">
        <div
          class="
            flex
            items-end
            sm:items-center
            justify-center
            min-h-full
            p-4
            text-center
            sm:p-0
          "
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="
                relative
                bg-gray-900
                border-2 border-gray-800
                rounded-lg
                px-4
                pt-5
                pb-4
                text-left
                overflow-hidden
                shadow-2xl
                transform
                transition-all
                sm:my-8 sm:max-w-lg sm:w-full sm:p-6
              "
            >
              <div class="sm:flex sm:items-start">
                <div
                  class="
                    mx-auto
                    flex-shrink-0 flex
                    items-center
                    justify-center
                    h-12
                    w-12
                    rounded-full
                    bg-transparent
                    sm:mx-0 sm:h-10 sm:w-10
                  "
                >
                  <ExclamationIcon
                    class="h-6 w-6 text-red-600"
                    aria-hidden="true"
                  />
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <DialogTitle
                    as="h3"
                    class="text-lg leading-6 font-medium text-gray-100"
                  >
                    {{ title }}
                  </DialogTitle>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">
                      {{ content }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="
                  mt-5
                  sm:mt-4 sm:flex sm:flex-row
                  justify-center
                  sm:gap-3
                  space-y-3
                  sm:space-y-0
                  pt-5
                "
              >
                <button
                  type="button"
                  class="
                    mt-3
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    shadow-sm
                    px-4
                    py-2
                    bg-gray-600
                    text-base
                    font-medium
                    text-white
                    hover:bg-gray-700
                    focus:outline-none
                    focus:ring-0
                    sm:mt-0 sm:w-auto sm:text-sm
                  "
                  @click="sendResponse('cancel')"
                  ref="cancelButtonRef"
                >
                  {{ buttonCancel }}
                </button>
                <button
                  type="button"
                  class="
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-transparent
                    shadow-sm
                    px-4
                    py-2
                    bg-red-600
                    text-base
                    font-medium
                    text-white
                    hover:bg-red-700
                    focus:outline-none
                    focus:ring-0
                    focus:ring-offset-0
                    focus:ring-red-500
                    sm:ml-3 sm:w-auto sm:text-sm
                  "
                  @click="sendResponse('ok')"
                >
                  {{ buttonSuccess }}
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { ref } from "vue";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { ExclamationIcon } from "@heroicons/vue/outline";
import emitter from "../utils/emitter.js";

//Init vars
const open = ref(false);
const title = ref("");
const content = ref("");
const buttonCancel = ref("Cancel");
const buttonSuccess = ref("Save");

const sendResponse = (value) => {
  open.value = false;
  emitter.emit("dialogResult", value);
};

emitter.on("showDialog", (payload) => {
  open.value = true;
  title.value = payload.title;
  content.value = payload.content;
  buttonCancel.value = payload.buttonCancel;
  buttonSuccess.value = payload.buttonSuccess;
});
</script>